import {
	Image,
	ImageBackground,
	ImageSourcePropType,
	ImageStyle,
	StyleProp,
	StyleSheet,
	Text,
	View,
} from 'react-native';

import { testProps } from '../../../config';
import { useDevice } from '../../../utils/hooks/useDevice';
import { TouchableOpacity } from '../common/Touchable';

export const ButtonCard = ({
	label,
	onPress,
	activeImage,
	inactiveImage,
	active,
	icon,
	iconStyle,
	labelStyle,
	testId,
}: {
	label: string;
	onPress: () => void;
	activeImage: any;
	inactiveImage: any;
	active?: boolean;
	icon?: ImageSourcePropType;
	iconStyle?: StyleProp<ImageStyle>;
	labelStyle?: StyleProp<ImageStyle>;
	testId?: string;
}) => {
	const { isMobile } = useDevice();

	return (
		<TouchableOpacity
			onPress={onPress}
			style={[styles.buttonContainer, isMobile ? { flex: 1 } : { marginHorizontal: -3 }]}
			{...testProps(testId)}
		>
			<ImageBackground
				source={active ? activeImage : inactiveImage}
				style={[styles.background, isMobile ? { width: '100%' } : { width: 190 }]}
				imageStyle={[{ resizeMode: 'stretch' }]}
			>
				<View style={styles.content}>
					{icon && <Image source={icon} style={[styles.icon, iconStyle]} resizeMode='contain' />}
					<Text style={[styles.label, labelStyle, { fontSize: isMobile ? 11 : 14 }]}>{label}</Text>
				</View>
			</ImageBackground>
		</TouchableOpacity>
	);
};

const styles = StyleSheet.create({
	buttonContainer: {
		alignItems: 'center',
		justifyContent: 'center',
	},
	background: {
		justifyContent: 'center',
		alignItems: 'center',
		height: 50,
	},
	label: {
		color: '#FFEAA0',
		fontWeight: 'bold',
		textTransform: 'uppercase',
		textAlign: 'center',
	},
	content: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100%',
		minHeight: 70,
	},
	icon: {
		height: 20,
		width: 20,
		marginRight: 6,
	},
});
